<p-button (onClick)="showDialog = true">Dodaj</p-button>

<ng-container *ngIf="showDialog">
  <p-dialog
    [resizable]="false"
    [(visible)]="showDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '100vw', height: '100vh' }"
    appendTo="body"
  >
    <h2>Odaberite korisnika čitaonice</h2>
    <app-odaberi-korisnika-citaonice
      (itemSelected)="onSelectedItem($event)"
    ></app-odaberi-korisnika-citaonice>
  </p-dialog>
</ng-container>
